import {
    Create,
    required,
    TextInput,
    BooleanInput,
    Link,
    useCreate,
    useNotify,
    useRedirect, TabbedForm, FormTab, NumberInput, minValue, FunctionField
} from "react-admin";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {EBooleanStatuses, EBooleanStatusesNumber} from "../../../Const/Enums";
import {useDispatch} from "react-redux";
import setLoadStatus from "../../../Store/LoaderReducer";
import {Calendar} from "react-multi-date-picker";
import {convertedDate, convertedDateWithTime} from "../../../Functions/ConvertedDate";

export const CreateWebinarHistory = () => {
    const initialRef = useRef(true);
    const [create] = useCreate();
    const notify = useNotify();
    const redirect = useRedirect();
    const dispatch = useDispatch();

    const onDateChange = (e) => {
        if (e && e.value.unix) {
            const date = new Date(e.value.unix * 1000);
            formData.show_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }
    }

    const [formData] = useState({
        name: '',
        description: '',
        show_date: '',
        order: 0,
        published: false,
        subscription: false
    });

    useEffect(() => {
        if (!initialRef.current) {
            return;
        }
        initialRef.current = false;
    }, [])

    const fileCreate = () => {
        if (!formData.name.length || formData.order <= 0) {
            if (!formData.name.length) {
                document.querySelector('.name').classList.add('error');
            }

            if (formData.order <= 0) {
                document.querySelector('.order').classList.add('error');
            }

            return;
        }

        dispatch(setLoadStatus(true));

        create('webinar-histories/general', {data: {
                name: formData.name,
                show_date: formData.show_date || document.getElementById('show_date').value,
                description: formData.description,
                order: formData.order,
                published: formData.published ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False,
                subscription: formData.subscription ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False
            }}, {
            onSuccess: (res) => {
                dispatch(setLoadStatus(false));
                redirect(`/webinar-histories/general/${res.id}/en`);
                notify('Webinar created');
            },
            onError: (res) => {
                dispatch(setLoadStatus(false));
                notify(res.message, 'warning');
            }
        });
    };

    const Save = () => {
        return (
            <div className="dailyActionToolbar">
                <Link to="/webinar-histories/general" className="button bar-purple-button">Cancel</Link>
                <button
                    onClick={fileCreate}
                    className="button bar-gradient-button"
                    type="button"
                >
                    <span>Save</span>
                </button>
            </div>
        );
    }

    const nameChange = (e) => {
        if (document.querySelector('.name').classList.contains('error')) {
            document.querySelector('.name').classList.remove('error');
        }
        formData.name = e.target.value;
    }

    const orderChange = (e) => {
        const val = +e.target.value;
        if (val <= 0) {
            document.querySelector('.order').classList.add('error');
            return;
        }
        if (document.querySelector('.order').classList.contains('error')) {
            document.querySelector('.order').classList.remove('error');
        }
        formData.order = val;
    }

    return (
        <>
            <h2 className="dailyTitle">New Webinar</h2>
            <Create title="Webinar">
                <TabbedForm className="tabbedForm" record={formData} toolbar={<></>}>
                    <FormTab label="General">
                        <div className="tabbedFormWrap">
                            <TextInput className="formFields name" label="Name" name="name" source="formData.name" fullWidth id="name" validate={required()} onChange={(e) => {nameChange(e)}} multiline />
                            <p className="required-text">Required</p>
                            <TextInput className="formFields" label="Description" name="description" source="formData.description" id="description" multiline fullWidth onChange={(e) => {formData.description = e.target.value}} />
                            <NumberInput label="Order" name="order" source="order" min={1} className="numberInput order" fullWidth id="order" validate={[required(), minValue(1)]} onChange={(e) => {orderChange(e)}} />
                            <p className="required-text">Must be at least 1</p>
                            <span className="showDateLabel">Show Date</span>
                            <FunctionField source="show_date" render={(record) => {
                                return (
                                    <>
                                        <Calendar
                                            value={record.show_date ? convertedDateWithTime(record.show_date) : null}
                                            onPropsChange={(e) => {
                                                onDateChange(e)
                                            }}
                                            minDate="2000/01/01"
                                            maxDate="3000/12/31"
                                        />
                                        <input type="hidden" id="show_date"
                                               value={record.show_date && !formData.show_date ? convertedDate(record.show_date) : formData.show_date}/>
                                    </>
                                );
                            }}/>
                            <BooleanInput label="Visible" name="published" source="formData.published" className="booleanInput" defaultValue={EBooleanStatuses.False} onChange={(e) => {formData.published = e.target.checked}}/>
                            <BooleanInput label="Subscription Required" source="subscription" className="booleanInput" defaultValue={EBooleanStatuses.False} onChange={(e) => {formData.subscription = e.target.checked}}/>
                        </div>
                        <Save />
                    </FormTab>
                    <FormTab label="EN" path="en" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                    <FormTab label="PT" path="pt" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                    <FormTab label="DE" path="de" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                </TabbedForm>
            </Create>
        </>
    );
}